import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

export const login = createAsyncThunk('auth/login', async (values, { rejectWithValue }) => {
  try {
    const response = await axios.post(`login`, values);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
});
export const validateToken = createAsyncThunk('auth/validateToken', async () => {
  const response = await axios.get(`Token`);
  return response.data;
});
export const refreshToken = createAsyncThunk('auth/refreshToken', async () => {
  const response = await axios.post(`GetADDetails/refreshtoken`);
  return response.data;
});
//Logout
export const logout = createAsyncThunk('auth/logout', async () => {
  const response = await axios.post(`logout`);
  return { status: response.status, data: response.data };
});
//trigger funtion to update  footer ClassName brfore and after login
export const triggerLoginStateChange = () => {
  const event = new Event('loginStateChange');
  window.dispatchEvent(event);
};

const initialState = {
  loading: false,
  error: null,
  userName: null,
  role: null,
};

const authSlice = createSlice({
  name: 'authenticatedUser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status === 200) {
          localStorage.setItem('userName', action.payload.data.userName);
          localStorage.setItem('role', action.payload.data.role);
          localStorage.setItem('domain', action.payload.data.fqdn);
          localStorage.setItem('dn', action.payload.data.dn);
          localStorage.setItem('domainDn', action.payload.data.domainDn);
          // Update axios Authorization header with fresh token after login
          const token = Cookies.get('access_token');
          if (token) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          }
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logout.fulfilled, (state, action) => {
        if (action.payload.status === 200) {
          state.userName = null;
          state.role = null;
          localStorage.removeItem('role');
          localStorage.removeItem('userName');
          localStorage.removeItem('dn');
          localStorage.removeItem('domain');
          localStorage.removeItem('domainDn');
          localStorage.removeItem('domainId');
          // Clear Authorization header on logout
          delete axios.defaults.headers.common['Authorization'];
          triggerLoginStateChange();
        }
      });
  },
});

export default authSlice.reducer;
